import { HOSTING_TYPES } from './analytics-builder-file-hosting';
import { getLoadFunctionByHostingType, initializeWindowVar } from './create-ajs-builder-file';
import hasCustomCdnPath from './hasCustomCdnPath';

const prepareAJSSnippet = (writekey, cdnURL, isCompressed, windowVariableName, fileHostingType) => {
  let hasPathName = false;
  if (cdnURL !== undefined) {
    if (fileHostingType === HOSTING_TYPES.metaRouter) {
      hasPathName = hasCustomCdnPath(cdnURL);
      if (!hasPathName) {
        cdnURL = new URL(cdnURL).hostname;
      }
    }
    cdnURL = cdnURL.replace(/^https?:\/\//, '');
  }
  let extension = '.js';
  if (isCompressed) {
    extension = '.js.gz';
  }
  const windowVarInit = initializeWindowVar(windowVariableName);
  const loadFunction = getLoadFunctionByHostingType(fileHostingType, cdnURL, extension, hasPathName);

  return `
<script type='text/javascript'>
!(function() {
  ${windowVarInit}
  var analytics = (window.${windowVariableName} = window.${windowVariableName} || [])
  if (!analytics.initialize) {
    if (analytics.invoked) {
      window.console && console.error && console.error('Analytics.js snippet included twice.')
    } else {
      analytics.invoked = !0
      analytics.methods = [
        'trackSubmit',
        'trackClick',
        'trackLink',
        'trackForm',
        'pageview',
        'identify',
        'reset',
        'group',
        'track',
        'ready',
        'alias',
        'debug',
        'page',
        'once',
        'off',
        'on',
        'addSourceMiddleware',
        'addIntegrationMiddleware',
        'setAnonymousId',
        'addDestinationMiddleware',
      ]
      analytics.factory = function(e) {
        return function() {
          var t = Array.prototype.slice.call(arguments)
          t.unshift(e)
          analytics.push(t)
          return analytics
        }
      }
      for (var e = 0; e < analytics.methods.length; e++) {
        var key = analytics.methods[e]
        analytics[key] = analytics.factory(key)
      }
      analytics.load = ${loadFunction}
      analytics.SNIPPET_VERSION = '4.13.1'
      analytics.load("${writekey}")
      window.${windowVariableName}.page()
    }
  }
})()
</script>`;
};

export default prepareAJSSnippet;
